<template>
  <div>
    <el-menu class="navbar" :class="[isFloor && 'tabs-box']" mode="horizontal">
      <div class="navbar-left">
        <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
        <breadcrumb class="breadcrumb-container"></breadcrumb>
      </div>

      <div class="right-menu">
        <!-- <el-tooltip effect="dark" content="全屏" placement="bottom">
          <screenfull class="screenfull right-menu-item"></screenfull>
        </el-tooltip> -->

        <div
          class="check-btn"
          :class="{ 'check-btn--alert': todoCount > 0 }"
          @click="goToTodoList"
          style="cursor: pointer;"
        >
          待办事项：{{ todoCount }}
        </div>
        <lang-select class="international right-menu-item"></lang-select>

        <!-- <el-tooltip effect="dark" content="换肤" placement="bottom">
        <theme-picker class="theme-switch right-menu-item"></theme-picker>
        </el-tooltip> -->

        <el-dropdown class="avatar-container right-menu-item" trigger="click">
          <div class="avatar-wrapper">
            <img class="user-avatar" src="../../../assets/user.jpg" />
            <i class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/">
              <el-dropdown-item>
                首页
              </el-dropdown-item>
            </router-link>
            <!-- <a :href="isO2O ? 'javascript:void(0)' : `${MixinBuyerDomain}`" :target="isO2O ? '' : '_blank'">
              <el-dropdown-item>
                浏览网站
              </el-dropdown-item>
            </a> -->
            <span @click="changePassword">
              <el-dropdown-item>修改密码</el-dropdown-item>
            </span>
            <span @click="logout">
              <el-dropdown-item divided>退出登录</el-dropdown-item>
            </span>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu>
    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="500px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="formRules" ref="form" label-width="100px">
        <!-- <el-form-item label="头像" prop="face">
          <el-upload
            :action="MixinUploadApi"
            list-type="picture"
            :on-success="(res) => { form.face = res.url }"
            :on-remove="() => { fileList = [],form.face = '' }"
            :file-list="fileList"
            :multiple="false"
            :limit="1"
            :on-exceed="() => { $message.error('文件数量超过限制！') }"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <span slot="tip" class="el-upload__tip">&nbsp;建议上传jpg/png文件，且不超过1MB</span>
          </el-upload>
        </el-form-item> -->
        <!-- <el-form-item label="原密码" prop="old_passwprd">
          <el-input v-model.trim="form.old_passwprd" placeholder="不修改则不填"></el-input>
        </el-form-item> -->
        <el-form-item label="新密码" prop="password">
          <el-input type="password" autocompete="off" v-model="form.password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="rep_password">
          <el-input type="password" autocompete="off" v-model="form.rep_password" placeholder="请确认密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitFormLoading" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import Screenfull from '@/components/Screenfull';
import LangSelect from '@/components/LangSelect';
import ThemePicker from '@/components/ThemePicker';
// import { RegExp } from '../../../../ui-utils'
import { api } from '../../../../ui-domain';
import * as API_Auth from '@/api/auth';
import * as API_Basic from '@/api/basic';

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    LangSelect,
    ThemePicker
  },
  data() {
    const user = this.MixinClone(this.$store.getters.user);
    return {
      dialogVisible: false,
      form: {
        face: user.face,
        old_passwprd: '',
        password: '',
        rep_password: ''
      },
      formRules: {
        face: [this.MixinRequired('请上传头像！')],
        old_passwprd: [{ required: false, message: '请输入原密码！', trigger: 'blur' }],
        password: [
          { required: false, message: '请输入新密码！', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value == null || value.length < 6) {
                callback(new Error('密码长度至少为6位！'));
              }
              var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error('密码应至少包含一位数字和字母！'));
              }
            }
          }
        ],
        rep_password: [
          { required: false, message: '请确认您的新密码！', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value && this.form.password !== value) {
                callback(new Error('两次输入不一致！'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      fileList: [],
      isFloor: false,
      submitFormLoading: false,
      todoCount: 0,
      notificationSource: null,
      notificationReconnectTimer: null
    };
  },
  computed: {
    ...mapGetters(['sidebar', 'user'])
  },
  mounted() {
    this.initBrowserNotification();
    this.loadTodoTotal();
    this.connectNotificationSSE();
  },
  beforeDestroy() {
    this.clearNotificationReconnectTimer();
    if (this.notificationSource) {
      this.notificationSource.close();
      this.notificationSource = null;
    }
  },
  watch: {
    form: {
      handler: function(newVal) {
        const { old_passwprd, password, rep_password } = newVal;
        const required = !!(old_passwprd || password || rep_password);
        this.formRules.old_passwprd[0].required = required;
        this.formRules.password[0].required = required;
        this.formRules.rep_password[0].required = required;
      },
      deep: true
    },
    dialogVisible: function(newVal) {
      if (!newVal) {
        this.fileList = [];
      }
    },
    $route() {
      if (this.$route.path === '/page/pc-decoration/floor') {
        this.isFloor = true;
      } else {
        this.isFloor = false;
      }
    }
  },
  methods: {
    /** 提交修改密码表单 */
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.submitFormLoading = true;
          const params = this.MixinClone(this.form);
          // if (!params.old_passwprd) {
          //   delete params.old_passwprd
          //   delete params.password
          //   delete params.rep_password
          // }
          API_Auth.editUserInfo(params)
            .then(() => {
              this.dialogVisible = false;
              this.$store.dispatch('fedLogoutAction');
              location.reload();
            })
            .finally(() => {
              this.submitFormLoading = false;
            });
        } else {
          this.$message.error('表单填写有误，请核对！');
        }
      });
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar');
    },
    changePassword() {
      this.fileList = this.form.face ? [{ name: 'face', url: this.form.face }] : [];
      this.dialogVisible = true;
    },
    goToTodoList() {
      this.loadTodoTotal();
      this.fetchAndCacheMenuNotifications()
        .finally(() => {
          if (this.$route.name === 'todolist') {
            // 已在待办页面，通知 dashboard 强制刷新数据
            this.$root.$emit('refresh-todolist');
            return;
          }
          this.$router.push({ name: 'todolist' }).catch(err => {
            if (err && err.name !== 'NavigationDuplicated') {
              console.error('跳转至待办事项失败', err);
            }
          });
        });
    },
    saveMenuNotificationsToLocalStorage(list) {
      try {
        localStorage.setItem('todolist_menu_notifications', JSON.stringify(Array.isArray(list) ? list : []));
      } catch (err) {
        console.error('保存待办事项到 localStorage 失败', err);
      }
    },
    loadMenuNotificationsFromLocalStorage() {
      try {
        const raw = localStorage.getItem('todolist_menu_notifications');
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (err) {
        console.error('从 localStorage 读取待办事项失败', err);
        return [];
      }
    },
    fetchAndCacheMenuNotifications() {
      return API_Basic.getTodoSummary()
        .then(response => {
          const list = Array.isArray(response)
            ? response
            : Array.isArray(response.data)
              ? response.data
              : Array.isArray(response.body)
                ? response.body
                : [];
          const normalized = list.map(item => ({
            ...item,
            menu_name: item.menu_name || item.matter_type_name || '',
            status_text: item.status_text || item.status_name || ''
          }));
          this.saveMenuNotificationsToLocalStorage(normalized);
          return normalized;
        })
        .catch(err => {
          console.error('请求待办摘要失败', err);
          return this.loadMenuNotificationsFromLocalStorage();
        });
    },
    logout() {
      this.$confirm('确定退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('logoutAction').then(() => {
            location.replace('/login'); // 为了重新实例化vue-router对象 避免bug
          });
        })
        .catch(() => {});
    },
    initBrowserNotification() {
      if (!('Notification' in window)) {
        return;
      }
      console.log('Browser notification supported:', true, 'current permission:', Notification.permission);
      if (Notification.permission === 'default') {
        Notification.requestPermission().then(permission => {
          console.log('Notification permission:', permission);
        });
      }
    },
    requestBrowserNotificationPermission() {
      if (!('Notification' in window)) {
        return Promise.resolve(false);
      }
      if (Notification.permission === 'granted') {
        return Promise.resolve(true);
      }
      if (Notification.permission === 'denied') {
        return Promise.resolve(false);
      }
      return Notification.requestPermission().then(permission => permission === 'granted');
    },
    async showBrowserNotification(title, options = {}, onClick) {
      if (!('Notification' in window)) {
        return false;
      }
      const granted = await this.requestBrowserNotificationPermission();
      console.log('showBrowserNotification permission:', Notification.permission, 'granted:', granted);
      if (!granted) {
        return false;
      }
      const notification = new Notification(title, {
        requireInteraction: true,
        ...options
      });
      if (typeof onClick === 'function') {
        notification.onclick = event => {
          event.preventDefault();
          window.focus();
          onClick();
          notification.close();
        };
      }
      return notification;
    },
    notifyFallback(payload) {
      this.$notify(payload);
    },
    clearNotificationReconnectTimer() {
      if (this.notificationReconnectTimer) {
        clearTimeout(this.notificationReconnectTimer);
        this.notificationReconnectTimer = null;
      }
    },
    scheduleNotificationReconnect() {
      this.clearNotificationReconnectTimer();
      this.notificationReconnectTimer = setTimeout(() => {
        this.reconnectNotificationSSE();
      }, 10 * 60 * 1000);
    },
    reconnectNotificationSSE() {
      if (this.notificationSource) {
        this.notificationSource.close();
        this.notificationSource = null;
      }
      this.connectNotificationSSE();
    },
    loadTodoTotal() {
      API_Basic.getTodoTotal()
        .then(response => {
          const count = response && (response.total || response.data || response.body || 0);
          this.todoCount = Number(count) || 0;
        })
        .catch(() => {
          this.todoCount = 0;
        });
    },
    connectNotificationSSE() {
      if (this.notificationSource) {
        return;
      }
      try {
        const baseUrl = api.base.replace(/\/$/, '');
        const url = `${baseUrl}/notification/sse/connect`;
        // const url = `/url/notification/sse/connect`;
        this.notificationSource = new EventSource(url,{ withCredentials: true });
        this.notificationSource.onmessage = async event => {
          try {
            const data = JSON.parse(event.data || '{}');
            console.log('SSE message', data);
            if (data.count > 0) {
              this.todoCount = data.count;
              await this.showBrowserNotification('待办提醒', {
                body: data.message || `您有 ${data.count} 条新的待处理事项`,
                icon: '',
                tag: 'todo-notification'
              }, () => {
                this.goToTodoList();
              });
              this.notifyFallback({
                title: '待办提醒',
                message: data.message || `您有 ${data.count} 条新的待处理事项`,
                type: 'warning',
                duration: 0,
                onClick: () => {
                  this.goToTodoList();
                }
              });
            }
          } catch (err) {
            console.error('SSE message parse error', err);
          }
        };
        this.notificationSource.onerror = (err) => {
          console.warn('SSE 连接异常', err);
          this.clearNotificationReconnectTimer();
          this.scheduleNotificationReconnect();
          console.log('SSE errrr',err);
          console.log('SSE errrr',JSON.stringify(err));
        };
        this.scheduleNotificationReconnect();
      } catch (err) {
        console.error('SSE 连接失败', err);
      }
    }
  }
};
</script>

<style type="text/scss" lang="scss" scoped>
@import '../../../styles/variables';
.el-dropdown-menu--small .el-dropdown-menu__item {
  min-width: 90px;
}
.navbar {
  height: 80px;
  border-radius: 0 !important;
  background-color: $nav_bg !important;
  border-color: $nav_bg !important;
  &.tabs-box {
    min-width: 1260px;
  }
  .navbar-left {
    float: left;
    display: flex;
    height: 80px;
    align-items: center;
  }
  .hamburger-container {
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
    /deep/ {
      .el-breadcrumb__separator,
      .el-breadcrumb__item .el-breadcrumb__inner a {
        color: $nav_text !important;
      }
      .el-breadcrumb__item .el-breadcrumb__inner .no-redirect {
        color: $nav_text_active !important;
      }
    }
  }
  .right-menu {
    display: flex;
    align-items: center;
    float: right;
    height: 80px;
    /deep/ svg {
      fill: $nav_text_active !important;
    }
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 15px;
    }

    .check-btn {
      width: 150px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      // line-height: 20px;
      color: #fff;
      border: 1px solid #fff;
      padding: 10px 20px;
      border-radius: 20px;
      transition: all 0.2s ease;
    }
    .check-btn--alert {
      color: #f56c6c;
      border-color: #f56c6c;
      background: rgba(245, 108, 108, 0.12);
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 100%;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
        /deep/ .el-icon-caret-bottom {
          color: $nav_text_active !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue